<template>
  <CourseList
    level-key="intermediateLevel"
    fetch-action="getCourseIntermediates"
    getter-name="courseIntermediates"
  />
</template>

<script>
import CourseList from "@/components/CourseList.vue";

export default {
  name: "IntermediateCourse",
  components: { CourseList },
};
</script>
